import React, { useState, useEffect } from 'react';
import { Field, withTypes } from 'react-final-form';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import { Card, Box, IconButton, Typography, InputAdornment, ThemeProvider } from '@material-ui/core';
import CardActions from '@material-ui/core/CardActions';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import { makeStyles, withStyles, Theme } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import { Visibility, VisibilityOff, } from '@material-ui/icons';
import { RouteComponentProps } from 'react-router-dom';
import { Notification } from 'react-admin';
import { useDataProvider, Loading, Error } from 'react-admin';
import { useTranslate, useAuthProvider } from 'ra-core';
import errLogo from '../assets/Error404.jpg'
import logo from '../assets/logo.png'
import PropTypes from "prop-types";
import mainLogo from '../assets/logo2.png'
import { useSelector } from 'react-redux';
import { darkTheme, lightTheme } from '../layout/themes';
import emailSend from '../assets/mailsend.png'
import Error404 from '../CustomizedUIs/Error'
import colors from '../CustomizedUIs/Colors'
const useStyles = makeStyles(theme => ({
    conainer: {
        minHeight: '100vh',
        [theme.breakpoints.up(500)]: {
            backgroundImage: 'url(/images/hopital-bg.jpg)',
        },
    },
    main: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        justifyItems: 'center',
    },
    card: {
        borderRadius:10,
        backgroundColor:'white',
        margin: 'auto',
        [theme.breakpoints.up('xs')]: {
            padding: '3em 3em'
        },
        [theme.breakpoints.down('xs')]: {
            padding: '3em 1em'
        },
    },
    avatar: {
        margin: '1em',
        display: 'flex',
        justifyContent: 'center',
    },
    icon: {
        backgroundColor: 'black',
    },
    hint: {
        marginTop: '1em',
        display: 'flex',
        justifyContent: 'center',
        color: theme.palette.grey[500],
    },
    form: {
        padding: '0 1em 1em 1em',
    },
    // input: {
    //     marginTop: '1em',
    // },
    actions: {
        padding: '0 1em 1em 1em',
    },
    link: {
        marginLeft: '1em',
        fontStyle: 'italic'
    },
    img: {
        margin: '5em auto',
        display: 'block'

    },
    text: {
        color: 'white',
        lineHeight: '0',
        fontWeight: 'bold'
    },
    h1: {
        fontSize: '72px',
        background: '-webkit-linear-gradient(blue, green)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        marginTop: '3em'
    }, TitleConfirmEmail: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '22px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: 'normal',
        color: 'rgba(0, 0, 0, 0.87)',
    },
    ConstentConfirmEmail: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '12px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: 'normal',
        color: 'rgba(0, 0, 0, 0.87)',
    },
    btnBackLogin: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: ' 0.44px',
    }, btnSignin: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: ' 0.44px',
        color: "#ffffff"
    }, textLabel: {
        marginBottom: 8,
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.13px',
        color: '#88898c',
    },
    textLableError: {

        marginBottom: 8,
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.13px',
        color: '#eb5a4d !important',
    },
    textError: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.36,
        letterSpacing: 'normal',
        color: '#eb5a4d !important',
    },
    underlineError: {
        '&::after': {
            borderBottom: '2px solid' + '#eb5a4d !important'
        }
    },
    focuses: {
        backgroundColor: 'white !important'
    },
    input: {
        backgroundColor: 'white',
        borderRadius: '2px',
        "&:hover": {
            backgroundColor: 'white'
        }, fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: '0.13px',
        color: '#88898c',
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: theme.palette.grey['200'],
        borderRightColor: theme.palette.grey['200'],
    },
    underline: {
        '&::before': {
            borderBottom: '1px solid black'
        },
        '&:hover:before': {
            borderBottom: '1px solid black'
        }
    },
    underlineNotValue: {
        '&::before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        },
        '&:hover:before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        }
    },
}));

const renderInput = ({
    meta: { touched, error } = { touched: false, error: undefined },
    input: { ...inputProps },
    ...props
}) => (
        <TextField
            error={!!(touched && error)}
            helperText={touched && error}
            {...inputProps}
            {...props}
            fullWidth
            variant="filled"
        />
    );

interface FormValues {
    password?: string;
    confirmPassword?: string;
}

const { Form } = withTypes<FormValues>();
type TParams = { token: string };
const ResetPassword = ({ match }: RouteComponentProps<TParams>) => {
    const [loading, setLoading] = useState(false);
    const [loadingPage, setLoaddingPage] = useState(true)
    const [isError, setIsError] = useState(false);
    const [errorValidate, setErrorValidate] = useState(true)
    const [isSuccess, setIsSuccess] = useState(false);
    const [showPassword, setShowPassword] = useState({
        password: false,
        confirmPassword: false
    });
    const [email, setEmail] = useState("");
    const translate = useTranslate();
    const classes = useStyles();
    const authProvider = useAuthProvider();
    const theme = useSelector((state: any) =>
        state.theme === 'dark' ? darkTheme : lightTheme
    );

    useEffect(() => {
        const token = match.params.token;
        authProvider
            .checkResetPasswordToken(token)
            .then((response: any) => {
                const data = response.data || {};
                setEmail(data.email);
                setLoaddingPage(false)
            }).catch(() => {
                setLoaddingPage(false)
            })
    })
    if (loadingPage) return <Loading></Loading>
    if (!email && !isSuccess) return (
        // <Box alignContent='center' textAlign='center'>
        //     <img src={errLogo} width="500" height="300" />
        //     <Box mt={10}>
        //         <Button
        //             color='primary'
        //             size='large'
        //             component={Link}
        //             href='/'
        //             style={{ margin: 'auto' }}>Back to login </Button>
        //     </Box>

        // </Box >
        <Error404></Error404>
    )


    const ColorButton = withStyles((theme: Theme) => ({
        root: {
            color: theme.palette.getContrastText(green[500]),
            backgroundColor: green[500],
            '&:hover': {
                backgroundColor: green[700],
            },
        }
    }))(Button);

    const handleSubmit = (value: any) => {
        setLoading(true);

        const data = {
            token: match.params.token,
            newPassword: value.password,
            confirmPassword: value.confirmPassword
        };

        authProvider
            .resetPassword(data)
            .then((response: any) => {
                if (response.success)
                    setIsSuccess(true);
            })
            .catch((e: any) => {

            })
    };

    const handleClickShowPassword = (prop: any) => {
        if (prop == "password")
            setShowPassword({
                ...showPassword, password: !showPassword.password
            });
        else
            setShowPassword({
                ...showPassword, confirmPassword: !showPassword.confirmPassword
            });
    };

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const validate = (values: FormValues) => {
        const errors: FormValues = {};

        if (!values.password) {
            errors.password = translate('ra.validation.required');
        }
        else if (!(values.password.length >= 6)) {
            errors.password = translate('pos.auth.errorlongcharacter')
        }
        else if (!(values.password.match(/[a-z]/) && values.password.match(/[A-Z]/)
            && values.password.match(/[0-9]/) && values.password.match(/[`!@#$%^&*_()+\-=\[\]{};':"\\|,.<>\/?~]/))) {
            errors.password = translate('pos.auth.errorspecial')
        }

        if (!values.confirmPassword) {
            errors.confirmPassword = translate('ra.validation.required');
        } else if (values.password !== values.confirmPassword)
            errors.confirmPassword = translate('pos.auth.errorsame')
        setErrorValidate(errors.password || errors.confirmPassword ? true : false)
        return errors;
    };
    return (
        <ThemeProvider theme={theme}>
            <div className={classes.conainer}>
                <div className={classes.main}>

                    <Form
                        onSubmit={handleSubmit}
                        validate={validate}
                        render={({ handleSubmit }) => (

                            <form onSubmit={handleSubmit} noValidate>
                                <Box>
                                    <Box className={classes.card}>
                                        <Box alignContent='center'>
                                            <Box width='100%' textAlign='center'>
                                                <img src={mainLogo} width='206px' height='48px' />
                                            </Box>
                                            {
                                                isSuccess ?
                                                    (
                                                        <Box width={400} my={3} textAlign='center'>
                                                            <Box display='flex' justifyContent='center' width='100%' mt={2}>
                                                                <img src={emailSend} width="230" height="230" />
                                                            </Box>
                                                            <Typography className={classes.TitleConfirmEmail}>{translate('pos.auth.resetSuccess')}</Typography>
                                                            <Button
                                                                color='primary'
                                                                size='large'
                                                                component={Link}
                                                                href='/'
                                                                style={{ marginTop: '16px' }}
                                                                className={classes.btnBackLogin}
                                                            >{translate('pos.auth.backtologin')}</Button>
                                                        </Box>
                                                    )
                                                    :
                                                    (
                                                        <Box my={3}>
                                                            <Typography className={classes.TitleConfirmEmail} >{translate(`pos.auth.Titleforceuser`)}</Typography>
                                                            <Box width={294} mt={1}>
                                                                <Typography style={{ cursor: 'pointer' }} className={classes.ConstentConfirmEmail} >{translate(`pos.auth.forcetitle`)}</Typography>
                                                                <Typography style={{ cursor: 'pointer' }} className={classes.ConstentConfirmEmail} >{translate(`pos.auth.titleforce`)}</Typography>
                                                            </Box>

                                                            <Box my={5}>
                                                                <Field
                                                                    name="password"
                                                                    // @ts-ignore
                                                                    component={renderInput}
                                                                    label={translate('pos.auth.password')}
                                                                    style={{ width: 400 }}
                                                                    disabled={loading}
                                                                    type={showPassword.password ? 'text' : 'password'}
                                                                    FormHelperTextProps={{
                                                                        className: classes.textError
                                                                    }}
                                                                    InputLabelProps={{
                                                                        // className: classes.textLabel,
                                                                        classes: {
                                                                            root: classes.textLabel,
                                                                            error: classes.textLableError
                                                                        }
                                                                    }}
                                                                    InputProps={{
                                                                        endAdornment: <InputAdornment position="end">
                                                                            {
                                                                                !errorValidate ? (
                                                                                    <IconButton
                                                                                        size='small'
                                                                                        aria-label="toggle password visibility"
                                                                                        onClick={() => handleClickShowPassword('password')}
                                                                                        onMouseDown={handleMouseDownPassword}
                                                                                    >
                                                                                        {showPassword.password ? <Visibility /> : <VisibilityOff />}
                                                                                    </IconButton>
                                                                                ) : <div></div>
                                                                            }

                                                                        </InputAdornment>,
                                                                        style: {
                                                                            fontFamily: 'UniviaPro',
                                                                            fontSize: '13px',
                                                                            fontWeight: 'normal',
                                                                            fontStretch: 'normal',
                                                                            fontStyle: 'normal',
                                                                            lineHeight: 1.85,
                                                                            letterSpacing: ' 0.13px',
                                                                            color: "#4f5064",
                                                                            backgroundColor: 'white',
                                                                            borderRadius: 0
                                                                        }
                                                                    }}

                                                                />
                                                            </Box>
                                                            <Box my={5}>
                                                                <Field
                                                                    name="confirmPassword"
                                                                    // @ts-ignore
                                                                    component={renderInput}
                                                                    label={translate('pos.auth.Confirmpassword')}
                                                                    style={{ width: 400 }}
                                                                    disabled={loading}
                                                                    type={showPassword.confirmPassword ? 'text' : 'password'}
                                                                    FormHelperTextProps={{
                                                                        className: classes.textError
                                                                    }}
                                                                    InputLabelProps={{
                                                                        // className: classes.textLabel,
                                                                        classes: {
                                                                            root: classes.textLabel,
                                                                            error: classes.textLableError
                                                                        }
                                                                    }}
                                                                    InputProps={{
                                                                        endAdornment: <InputAdornment position="end">
                                                                            {
                                                                                !errorValidate ? (
                                                                                    <IconButton
                                                                                        size='small'
                                                                                        aria-label="toggle password visibility"
                                                                                        onClick={() => handleClickShowPassword('confirmPassword')}
                                                                                        onMouseDown={handleMouseDownPassword}
                                                                                    >
                                                                                        {showPassword.confirmPassword ? <Visibility /> : <VisibilityOff />}
                                                                                    </IconButton>
                                                                                ) : <div></div>
                                                                            }

                                                                        </InputAdornment>,
                                                                        style: {
                                                                            fontFamily: 'UniviaPro',
                                                                            fontSize: '13px',
                                                                            fontWeight: 'normal',
                                                                            fontStretch: 'normal',
                                                                            fontStyle: 'normal',
                                                                            lineHeight: 1.85,
                                                                            letterSpacing: ' 0.13px',
                                                                            color: "#4f5064",
                                                                            backgroundColor: 'white',
                                                                            borderRadius: 0
                                                                        }
                                                                    }}

                                                                />
                                                            </Box>

                                                            <Box width='100%' display='flex' justifyContent='flex-end'>
                                                                <Button
                                                                    variant="contained"
                                                                    type="submit"
                                                                    color="primary"
                                                                    disabled={loading || errorValidate}
                                                                >
                                                                    {loading && (
                                                                        <CircularProgress
                                                                            size={25}
                                                                            thickness={2}
                                                                            color='inherit'
                                                                        />
                                                                    )}
                                                                    <Typography style={{ padding: "10px" }} className={classes.btnSignin}>{translate(`pos.auth.submitpassword`)}</Typography>
                                                                </Button>
                                                            </Box>
                                                        </Box>
                                                    )
                                            }
                                        </Box>
                                    </Box>
                                </Box>
                            </form>
                        )}
                    />


                </div>
            </div>
        </ThemeProvider>
    );
};

ResetPassword.propTypes = {
    authProvider: PropTypes.func
};

export default ResetPassword;
